import React from 'react';
export default (props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "container d-flex flex-wrap body-wrapper bg-white"
  }, /*#__PURE__*/React.createElement("main", {
    className: "col-12 order-lg-2",
    role: "main",
    "aria-label": "Main Content Area"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col content content-fullwidth"
  }, props.children))));
});